// extracted by mini-css-extract-plugin
export default {"wrapper":"Profile_wrapper__hTwrt"};